import { OnInit, Component, Input } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { UserService } from 'src/app/services/user.service';
import { HttpAlertService } from 'src/app/services/http-alert.service';
import { TranslateService } from '@ngx-translate/core';
import { AdminService } from 'src/app/services/admin.service';
import { ArrangerDetails } from 'src/app/intefaces/arranger-details.interface';

@Component({
    selector: 'app-arranger-details-form',
    templateUrl: './arranger-details-form.component.html',
    styleUrls: ['./arranger-details-form.component.scss']
})
export class ArrangerDetailsFormComponent implements OnInit {

    @Input() isAdmin: boolean;
    @Input() userId: number;

    isDataReady: boolean = false;
    isEditingShortDesc: boolean = false;
    isEditingFullDesc: boolean = false;
    isEditingArrangerDetails: boolean = false;
    arrangerDetailsForm: FormGroup;
    shortDescForm: FormGroup;
    fullDescForm: FormGroup;
    arrangerDetailsFormPreviousValues: any;
    shortDescFormPreviousValues: any;
    fullDescFormPreviousValues: any;
    arrangerDetails: ArrangerDetails;

    constructor(
        private formBuilder: FormBuilder,
        private userService: UserService,
        private alertService: HttpAlertService,
        private translate: TranslateService,
        private adminService: AdminService) {

        this.shortDescForm = this.formBuilder.group({
            user_id: [0,Validators.required],
            short_description: ['', Validators.maxLength(255)],
        });
        this.fullDescForm = this.formBuilder.group({
            user_id: [0,Validators.required],
            description: [''],
        });
        this.arrangerDetailsForm = this.formBuilder.group({
            user_id: [0,Validators.required],
            pesel: ['', [Validators.required, Validators.maxLength(11)]],
            tax_number: ['', Validators.maxLength(20)],
            country: ['', [Validators.required, Validators.maxLength(50)]],
            city: ['', [Validators.required, Validators.maxLength(50)]],
            street: ['', [Validators.required, Validators.maxLength(50)]],
            street_number: ['', [Validators.required, Validators.maxLength(10)]],
            apartment_number: ['', [Validators.maxLength(10)]],
            postal_code: ['', [Validators.required, Validators.maxLength(10)]],
            bank_name: ['', [Validators.required, Validators.maxLength(255)]],
            account_number: ['', [Validators.required, Validators.minLength(26), Validators.maxLength(26)]],
            b2b: [false]
        });
    }

    ngOnInit(): void {
        if(this.isAdmin){
            this.adminService.getArrangerDetailsByAdmin(this.userId).subscribe((response: any) => { 
                this.arrangerDetails = response.data;
                this.populateForm(response.data); 
            });
        } else {
            this.userService.getArrangerDetails().subscribe(
                data => { this.populateForm(data.data); }
            );
        } 
    }

    private populateForm(arrangerDetails: ArrangerDetails): void{
        if (arrangerDetails != null) {
            this.shortDescForm.patchValue(arrangerDetails);
            this.fullDescForm.patchValue(arrangerDetails);
            this.arrangerDetailsForm.patchValue(arrangerDetails);    
            setTimeout(() => {
                this.arrangerDetailsForm.disable();
                this.shortDescForm.disable();
                this.fullDescForm.disable();
                this.isDataReady = true;
            }, 300);
        }
    }
    
    public onSubmitFullDesc() {
        this.fullDescForm.disable();
        if(this.isAdmin){
            this.adminService.updateFullDescByAdmin(this.fullDescForm.value).subscribe(
                result => { this.translate.get('data_updated_success').subscribe(t => { this.alertService.success(t) }); },
                error => { this.translate.get('data_updated_error').subscribe(t => { this.alertService.error(t) }); }
            );
        } else {
            this.userService.updateFullDesc(this.fullDescForm.value).subscribe(
                result => { this.translate.get('data_updated_success').subscribe(t => { this.alertService.success(t) }); },
                error => { this.translate.get('data_updated_error').subscribe(t => { this.alertService.error(t) }); }
            );
        }
        this.isEditingFullDesc = false;
    }

    public onSubmitShortDesc() {
        this.shortDescForm.disable();
        if(this.isAdmin){
            this.adminService.updateShortDescByAdmin(this.shortDescForm.value).subscribe(
                result => { this.translate.get('data_updated_success').subscribe(t => { this.alertService.success(t) }); },
                error => { this.translate.get('data_updated_error').subscribe(t => { this.alertService.error(t) }); }
            );
        } else {
            this.userService.updateShortDesc(this.shortDescForm.value).subscribe(
                result => { this.translate.get('data_updated_success').subscribe(t => { this.alertService.success(t) }); },
                error => { this.translate.get('data_updated_error').subscribe(t => { this.alertService.error(t) }); }
            );
        }
        this.isEditingShortDesc = false;
    }

    public onSubmitArrangerDetails() {
        this.arrangerDetailsForm.disable();
        if(this.isAdmin){
            this.adminService.updateArrangerDetails(this.arrangerDetailsForm.value).subscribe(
                result => { this.translate.get('data_updated_success').subscribe(t => { this.alertService.success(t) }); },
                error => { this.translate.get('data_updated_error').subscribe(t => { this.alertService.error(t) }); }
            );
        } else {
            this.userService.updateArrangerDetails(this.arrangerDetailsForm.value).subscribe(
                result => { this.translate.get('data_updated_success').subscribe(t => { this.alertService.success(t) }); },
                error => { this.translate.get('data_updated_error').subscribe(t => { this.alertService.error(t) }); }
            );
        }
        this.isEditingArrangerDetails = false;

    }

    public onCancelFullDesc() {
        this.fullDescForm.setValue(this.fullDescFormPreviousValues);
        this.isEditingFullDesc = false;
        this.fullDescForm.disable();
    }

    public onCancelShortDesc() {
        this.shortDescForm.setValue(this.shortDescFormPreviousValues);
        this.isEditingShortDesc = false;
        this.shortDescForm.disable();
    }

    public onCancelArrangerDetails() {
        this.arrangerDetailsForm.setValue(this.arrangerDetailsFormPreviousValues);
        this.arrangerDetailsForm.disable();
        this.isEditingArrangerDetails = false;
    }

    public onStartEditingFullDesc() {
        this.fullDescFormPreviousValues = this.fullDescForm.value;
        this.isEditingFullDesc = true;
        this.fullDescForm.enable();
    }

    public onStartEditingShortDesc() {
        this.shortDescFormPreviousValues = this.shortDescForm.value;
        this.isEditingShortDesc = true;
        this.shortDescForm.enable();
    }

    public onStartEditingArrangerDetails() {
        this.arrangerDetailsFormPreviousValues = this.arrangerDetailsForm.value;            
        this.isEditingArrangerDetails = true;
        this.arrangerDetailsForm.enable();
    }


}